import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.report.queries.app-api`, {
  'reports.actions.errors.metrics-api-default': `Sorry, something went wrong. Please contact support if this problem persists.`,
});
